// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@7.1.5_@rspack+core@2.2.3_webpack@5.105.2/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@7.1.5_@rspack+core@2.2.3_webpack@5.105.2/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.YN6kLyWooBA4H6 {
  width: 100%;
  position: relative;
}

.WEJEKPGCGVVQfF {
  box-sizing: border-box;
  width: 100%;
  padding: var(--ds-space-150, 12px);
  padding-bottom: var(--ds-space-1000, 80px);
  border: var(--ds-border-width, 1px) solid var(--ds-border, #091e4224);
  border-radius: var(--ds-radius-medium, 6px);
  background-color: var(--ds-surface, #fff);
  resize: none;
  overflow-y: hidden;
}

.qY1XpAxMWZ8vi9 {
  justify-content: space-between;
  align-items: center;
  gap: var(--ds-space-100, 8px);
  padding: var(--ds-space-100, 8px) var(--ds-space-100, 8px) var(--ds-space-075, 6px) var(--ds-space-150, 12px);
  border-radius: 0 0 var(--ds-radius-medium, 6px) var(--ds-radius-medium, 6px);
  background-color: var(--ds-surface-sunken, #f7f8f9);
  display: flex;
  position: absolute;
  bottom: 7px;
  left: 2px;
  right: 2px;
}

.B4sfHAwkUkmdeZ {
  align-items: center;
  gap: var(--ds-space-100, 8px);
  flex-direction: row;
  display: flex;
}

.DPgC411PtA5NgR {
  align-items: center;
  display: flex;
}

.DPgC411PtA5NgR > label > input {
  align-self: center;
}

.IdyauFyyKbTJC4 {
  border-radius: var(--ds-radius-medium, 6px);
  gap: var(--ds-space-150, 12px);
}

.l7WrsSgq4onMod {
  align-items: center;
  gap: var(--ds-space-100, 8px);
  display: flex;
}

.KKkaQ9_OBUqwNL {
  opacity: 0;
  pointer-events: none;
  align-items: center;
  transition: opacity .5s ease-in-out;
  display: flex;
}

.BDaIRm1KVa6dXB {
  opacity: 1;
  transition: none;
}
`, ""]);
// Exports
export var container = `YN6kLyWooBA4H6`;
export var textarea = `WEJEKPGCGVVQfF`;
export var footer = `qY1XpAxMWZ8vi9`;
export var radioGroup = `B4sfHAwkUkmdeZ`;
export var radioGroupItem = `DPgC411PtA5NgR`;
export var button = `IdyauFyyKbTJC4`;
export var addRuleGroup = `l7WrsSgq4onMod`;
export var savedIndicator = `KKkaQ9_OBUqwNL`;
export var savedIndicatorVisible = `BDaIRm1KVa6dXB`;
export default ___CSS_LOADER_EXPORT___;
